import {
  SITEMANAGELIST
} from '../actions/siteManage';

import {reducerPackage} from "../../utils";

export const siteManageList = reducerPackage(SITEMANAGELIST);

